/* ==========================================================================
   mopeddruck.js — Quick-Add „Komplett" und die Kern-Zuordnung

   DAS EIGENTLICHE PROBLEM

   Ein Lenkerpolster besteht aus zwei Artikeln: dem bedruckten Blatt und dem
   Schaumstoffkern. Wer nur das Blatt bestellt, bekommt eine Huelle ohne
   Inhalt — das war laut Datenanalyse der Grund fuer 586 Nachbestellungen im
   Quartal. „Quick-Add · Komplett" legt deshalb BEIDE Artikel in einem
   einzigen Aufruf in den Warenkorb.

   Der Haken ist die Groesse. Das Blatt fuehrt sie in Zentimetern
   („23.5cm / Gelb"), der Kern in Millimetern („235mm"). Ohne Zuordnung
   landete immer dieselbe Kerngroesse im Korb — und jede zweite Bestellung
   waere falsch. Die Ableitung steht unten in `kernFuer()`:

     23.5cm → 235mm     19.5cm → 195mm     23,5 cm → 235mm

   Sie faengt Punkt und Komma ab, mit und ohne Leerzeichen. Geprueft an allen
   38 Polstern des Shops: 37 lassen sich zuordnen. Das eine, das uebrig
   bleibt, ist das Custom Motorradpolster — es hat gar keine Groessenoption
   und auch keinen passenden Kern. Findet die Zuordnung nichts, wird NUR das
   Blatt gelegt und der Kern still weggelassen. Lieber ein Artikel zu wenig
   als der falsche.
   ========================================================================== */

(function () {
  'use strict';

  /* ---- Kerndaten aus dem Markup lesen ---------------------------------- */

  function kernDaten() {
    var el = document.getElementById('md-kern-daten');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  /* Aus „23.5cm / Gelb" wird „235mm". Gibt null zurueck, wenn keine
     Zentimeterangabe drinsteht. */
  function millimeter(titel) {
    if (!titel) return null;
    var treffer = String(titel).match(/([\d]+)[.,]?([\d]*)\s*cm/i);
    if (!treffer) return null;
    var ganz = parseInt(treffer[1], 10);
    var nach = treffer[2] ? parseInt(treffer[2][0], 10) : 0;
    return String(ganz * 10 + nach) + 'mm';
  }

  /* Passende Kern-Variante zu einem Blatt-Variantentitel. */
  function kernFuer(blattTitel) {
    var daten = kernDaten();
    if (!daten || !daten.varianten || !daten.varianten.length) return null;

    var gesucht = millimeter(blattTitel);
    if (!gesucht) return null;

    for (var i = 0; i < daten.varianten.length; i++) {
      var v = daten.varianten[i];
      if (!v.verfuegbar) continue;
      /* Der Kerntitel ist schlicht „195mm" — aber wir vergleichen tolerant,
         falls dort einmal „Größe: 195 mm" steht. */
      var titel = String(v.titel).replace(/\s+/g, '').toLowerCase();
      if (titel.indexOf(gesucht.toLowerCase()) !== -1) return v;
    }
    return null;
  }

  /* ---- In den Warenkorb ------------------------------------------------- */

  function schublade() {
    return document.querySelector('cart-drawer');
  }

  /* Den Zaehler am Warenkorb-Symbol nachziehen.

     Dawn erledigt das normalerweise selbst, indem es seine Section
     `cart-icon-bubble` neu rendert und austauscht. Die Kopfzeile hier ist
     aber eine eigene Section — der Austausch findet also kein Ziel, und der
     Zaehler blieb nach dem Hinzufuegen leer. Gemessen: zwei Artikel im
     Korb, keine Blase am Symbol.

     Ein Aufruf von /cart.js kostet wenig und ist unabhaengig davon, wie die
     Kopfzeile heisst. Richtigkeit vor einer eingesparten Anfrage. */
  /* WARUM HIER AUFGERAEUMT WIRD STATT NUR ANGEHAENGT

     Es gibt ZWEI Stellen, die eine Blase erzeugen:

       Dawn    `cart-drawer.js` und `cart.js` rendern die Section
               `cart-icon-bubble` neu und ersetzen den Inhalt von
               `#cart-icon-bubble`. Dabei entsteht Dawns eigene Blase:
               `<div class="cart-count-bubble">` — gelb aus `--color-button`,
               unten links, OHNE `md-kopf__zaehler`.

       hier    diese Funktion.

     Die alte Fassung suchte nur `.md-kopf__zaehler`. Nach einem Dawn-Render
     fand sie nichts mehr und haengte eine zweite Blase an — sichtbar als
     zwei Zahlen uebereinander, rot oben rechts und gelb unten links.

     Gesucht wird deshalb `.cart-count-bubble`: die Klasse tragen beide.
     Ueberzaehlige fliegen raus, die erste wird auf die Theme-Form gebracht.

     Die innere Aufteilung bleibt erhalten — Product Personalizer (Zepto)
     stempelt seine Klasse `pplr_cart_count` auf die sichtbare Zahl, um sie
     selbst nachzuziehen. Wer hier `textContent` setzt, wirft dieses Element
     samt Klasse weg. */
  function blaseNormalisieren(anzahl) {
    var symbol = document.getElementById('cart-icon-bubble');
    if (!symbol) return;

    var blasen = [].slice.call(symbol.querySelectorAll('.cart-count-bubble'));

    if (!anzahl) {
      blasen.forEach(function (b) { b.remove(); });
      symbol.setAttribute('aria-label', 'Warenkorb');
      return;
    }

    var blase = blasen.shift();
    blasen.forEach(function (b) { b.remove(); });

    if (!blase) {
      blase = document.createElement('span');
      symbol.appendChild(blase);
    }
    /* Dawn liefert ein <div>. Das Aussehen haengt an der Klasse, nicht am
       Element — umbauen waere unnoetig. */
    blase.className = 'cart-count-bubble md-kopf__zaehler';

    var sichtbar = blase.querySelector('[aria-hidden="true"]');
    var vorleser = blase.querySelector('.visually-hidden');
    if (!sichtbar) {
      sichtbar = document.createElement('span');
      sichtbar.setAttribute('aria-hidden', 'true');
      blase.insertBefore(sichtbar, blase.firstChild);
    }
    if (!vorleser) {
      vorleser = document.createElement('span');
      vorleser.className = 'visually-hidden';
      blase.appendChild(vorleser);
    }
    sichtbar.textContent = anzahl;
    vorleser.textContent = anzahl + ' Artikel';
    symbol.setAttribute('aria-label', 'Warenkorb, ' + anzahl + ' Artikel');
  }

  /* Dawn rendert die Section auch auf Wegen, die durch diese Datei nicht
     laufen — etwa aus der Schublade heraus. Ein Beobachter faengt das ab,
     ohne dass jeder dieser Wege bekannt sein muss. `subtree: false` genuegt:
     Es geht nur um Kinder direkt unter dem Symbol. */
  function blaseBeobachten() {
    var symbol = document.getElementById('cart-icon-bubble');
    if (!symbol || typeof MutationObserver === 'undefined') return;
    new MutationObserver(function () {
      if (symbol.querySelectorAll('.cart-count-bubble').length < 2) return;
      /* Die Zahl NICHT aus dem Markup ablesen.

         Eine Blase enthaelt zwei Texte — die sichtbare Ziffer und die
         Vorleser-Zeile „2 Artikel". `textContent` liefert beide am Stueck,
         aus 1 und „1 Artikel" wurde so die Menge 11. Und bei zwei Blasen
         waere ohnehin offen, welche die aktuelle ist.

         Der Warenkorb weiss es sicher. Der Aufruf erfolgt nur, wenn
         tatsaechlich doppelt gerendert wurde — also selten. Das Aufraeumen
         loest den Beobachter erneut aus, faellt dann aber oben schon
         wieder heraus. Keine Schleife. */
      zaehlerAuffrischen();
    }).observe(symbol, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', blaseBeobachten);
  } else {
    blaseBeobachten();
  }

  function zaehlerAuffrischen() {
    return fetch((window.routes ? window.routes.cart_url : '/cart') + '.js')
      .then(function (a) { return a.json(); })
      .then(function (korb) { blaseNormalisieren(korb.item_count); })
      .catch(function () { /* Zaehler ist Beiwerk — nie den Kauf blockieren */ });
  }

  /* Dawn laedt die betroffenen Abschnitte gleich mit und rendert sie neu.
     Genau dieses Muster wird hier uebernommen, damit Zaehler und Schublade
     ohne zweiten Aufruf stimmen. */
  function abschnitte() {
    var d = schublade();
    if (d && typeof d.getSectionsToRender === 'function') {
      return d.getSectionsToRender().map(function (s) { return s.id; });
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function lege(artikel, knopf) {
    var wort = knopf ? knopf.textContent : '';
    if (knopf) { knopf.disabled = true; knopf.textContent = '…'; }

    var koerper = {
      items: artikel,
      sections: abschnitte(),
      sections_url: window.location.pathname
    };

    return fetch(window.routes ? window.routes.cart_add_url : '/cart/add', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript'
      },
      body: JSON.stringify(koerper)
    })
      .then(function (a) { return a.json(); })
      .then(function (antwort) {
        if (antwort.status) throw new Error(antwort.description || antwort.message);

        var d = schublade();
        if (d && typeof d.renderContents === 'function') {
          d.classList.remove('is-empty');
          d.renderContents(antwort);
        } else {
          window.location = window.routes ? window.routes.cart_url : '/cart';
        }
        return zaehlerAuffrischen();
      })
      .catch(function (f) {
        console.warn('[mopeddruck] Hinzufuegen fehlgeschlagen:', f.message);
        window.location = window.routes ? window.routes.cart_url : '/cart';
      })
      .then(function () {
        if (knopf) { knopf.disabled = false; knopf.textContent = wort; }
      });
  }

  /* ---- Quick-Add ------------------------------------------------------- */

  document.addEventListener('click', function (e) {
    var knopf = e.target.closest ? e.target.closest('[data-md-quickadd]') : null;
    if (!knopf) return;
    e.preventDefault();

    var blattId = parseInt(knopf.dataset.blattVariante, 10);
    if (!blattId) return;

    var artikel = [{ id: blattId, quantity: 1 }];

    if (knopf.dataset.brauchtKern === 'true') {
      var kern = kernFuer(knopf.dataset.blattTitel);
      if (kern) {
        artikel.push({ id: kern.id, quantity: 1 });
      }
      /* Kein Kern gefunden: siehe Kopf dieser Datei — dann eben nur das
         Blatt. Der Besucher kann den Kern auf der Produktseite nachlegen. */
    }

    lege(artikel, knopf);
  });

  /* Nach aussen sichtbar machen, damit die Produktseite dieselbe Zuordnung
     benutzt statt einer zweiten Fassung. */
  window.mopeddruck = window.mopeddruck || {};
  window.mopeddruck.kernFuer = kernFuer;
  window.mopeddruck.millimeter = millimeter;
  window.mopeddruck.lege = lege;
})();

/* ==========================================================================
   Produktseite — Variantenwahl, Live-Summe, Bundle-Schalter, feste Leiste
   ========================================================================== */

(function () {
  'use strict';

  var pdp = document.querySelector('[data-md-pdp]');
  if (!pdp) return;

  var M = window.mopeddruck || {};

  var quelle = pdp.querySelector('[data-md-varianten]');
  var varianten = [];
  try { varianten = JSON.parse(quelle.textContent); } catch (e) { return; }

  var felder = [].slice.call(pdp.querySelectorAll('[data-md-option]'));
  var versteckt = pdp.querySelector('[data-md-variante]');
  var preisEl = pdp.querySelector('[data-md-preis]');
  var streichEl = pdp.querySelector('[data-md-streich]');
  var bundle = pdp.querySelector('[data-md-bundle]');
  var bundleKarte = pdp.querySelector('[data-md-bundle-karte]');
  var atc = pdp.querySelector('[data-md-atc]');
  var leiste = pdp.querySelector('[data-md-leiste]');
  /* UEBER DEN CONTAINER GEHOLT, NICHT UEBER DIE KENNUNG.

     `image_tag` gibt in diesem Theme weder `class` noch `id` weiter — das
     `<img>` kommt ohne beides heraus. `#md-hauptbild` fand deshalb nie
     etwas, und weil die Zuweisung mit `if (hauptbild && …)` abgesichert
     ist, passierte einfach nichts: kein Fehler, keine Meldung, das Bild
     blieb beim Farbwechsel stehen.

     Die Kennung wird zuerst versucht, falls Shopify sie eines Tages doch
     durchreicht; danach der Container. */
  var hauptbild = pdp.querySelector('#md-hauptbild') || pdp.querySelector('.md-pdp__buehne img');

  /* Geld wie Shopify es formatiert — ohne den Filter nachzubauen. Das
     Muster kommt aus dem bereits gerenderten Preis: steht dort „€16,37",
     wird auch die Summe so gesetzt. Sonst staenden zwei Formate auf einer
     Seite. */
  var muster = preisEl ? preisEl.textContent.trim() : '0';
  function geld(cent) {
    var zahl = (cent / 100).toFixed(2);
    var mitKomma = zahl.replace('.', ',');
    return muster.replace(/[\d.,]+/, mitKomma);
  }

  /* Die Optionsgruppen sind jetzt Radiogruppen, keine Auswahlfelder mehr.
     Gelesen wird der angehakte Knopf je Gruppe — die Gruppen sind ueber
     `name="md-option-N"` sauber getrennt (N kommt aus der aeusseren
     Schleife im Liquid, siehe dortigen Kommentar). */
  function wertVon(gruppe) {
    if (gruppe.value !== undefined && gruppe.tagName === 'SELECT') return gruppe.value;
    var an = gruppe.querySelector('input[type="radio"]:checked');
    return an ? an.value : null;
  }

  function aktuelle() {
    if (!felder.length) return varianten[0];
    var gewaehlt = felder.map(wertVon);
    for (var i = 0; i < varianten.length; i++) {
      var v = varianten[i];
      var passt = true;
      for (var j = 0; j < gewaehlt.length; j++) {
        if (String(v.optionen[j]) !== String(gewaehlt[j])) { passt = false; break; }
      }
      if (passt) return v;
    }
    return null;
  }

  function summe(v) {
    var wert = v ? v.preis : 0;
    if (bundle && bundle.checked && M.kernFuer) {
      var kern = M.kernFuer(v ? v.titel : '');
      if (kern) wert += kern.preis;
    }
    return wert;
  }

  function auffrischen() {
    var v = aktuelle();

    if (versteckt && v) versteckt.value = v.id;
    if (preisEl && v) preisEl.textContent = geld(v.preis);

    if (streichEl) {
      if (v && v.vergleich && v.vergleich > v.preis) {
        streichEl.textContent = geld(v.vergleich);
        streichEl.hidden = false;
      } else {
        streichEl.hidden = true;
      }
    }

    if (hauptbild && v && v.bild) {
      /* `srcset` muss mit weg. Bleibt es stehen, waehlt der Browser
         weiterhin daraus und ignoriert das neue `src` — das Bild haette
         sich scheinbar zufaellig mal geaendert und mal nicht. */
      hauptbild.removeAttribute('srcset');
      hauptbild.src = v.bild;

      /* Das passende Vorschaubild mitmarkieren, sonst zeigt die Leiste
         weiter auf ein anderes Motiv als die Buehne. */
      var treffer = v.bild.split('?')[0];
      [].forEach.call(pdp.querySelectorAll('[data-md-thumb]'), function (x) {
        var gross = (x.dataset.gross || '').split('?')[0];
        x.classList.toggle('md-pdp__thumb--aktiv', gross === treffer);
      });
    }

    if (bundleKarte && bundle) bundleKarte.classList.toggle('is-aus', !bundle.checked);

    /* Der Bundle-Schalter ist sinnlos, wenn es zur gewaehlten Laenge keinen
       Kern gibt. Dann verschwindet er, statt eine Zusage zu machen, die
       nicht eingeloest wird. */
    if (bundleKarte && M.kernFuer) {
      var passend = v ? M.kernFuer(v.titel) : null;
      bundleKarte.hidden = !passend;
    }

    var text = geld(summe(v));
    [].forEach.call(pdp.querySelectorAll('[data-md-summe]'), function (el) {
      el.textContent = text;
    });

    var kaufbar = !!(v && v.verfuegbar);
    if (atc) {
      atc.disabled = !kaufbar;
      if (!kaufbar) atc.textContent = 'Ausverkauft';
    }
    if (leiste) leiste.classList.toggle('md-pdp__leiste--aus', !kaufbar);
  }

  /* Mengenwaehler. Der Wert wandert ueber das Feld selbst ins Formular —
     es traegt `name="quantity"`, ein zweites verstecktes Feld gibt es
     deshalb nicht. */
  var mengenfeld = pdp.querySelector('[data-md-mengenfeld]');
  [].forEach.call(pdp.querySelectorAll('[data-md-menge]'), function (k) {
    k.addEventListener('click', function () {
      if (!mengenfeld) return;
      var neu = (parseInt(mengenfeld.value, 10) || 1) + parseInt(k.dataset.mdMenge, 10);
      mengenfeld.value = Math.max(1, neu);
    });
  });

  felder.forEach(function (f) {
    f.addEventListener('change', function () {
      /* Sichtbare Markierung der gewaehlten Pille. */
      [].forEach.call(f.querySelectorAll('.md-pdp__wert'), function (l) {
        var r = l.querySelector('input[type="radio"]');
        l.classList.toggle('is-gewaehlt', !!(r && r.checked));
      });
      auffrischen();
    });
    [].forEach.call(f.querySelectorAll('.md-pdp__wert'), function (l) {
      var r = l.querySelector('input[type="radio"]');
      if (r && r.checked) l.classList.add('is-gewaehlt');
    });
  });
  if (bundle) bundle.addEventListener('change', auffrischen);

  /* Thumbnails wechseln nur das Bild. */
  [].forEach.call(pdp.querySelectorAll('[data-md-thumb]'), function (t) {
    t.addEventListener('click', function () {
      if (hauptbild) {
        hauptbild.removeAttribute('srcset');
        hauptbild.src = t.dataset.gross;
      }
      [].forEach.call(pdp.querySelectorAll('[data-md-thumb]'), function (x) {
        x.classList.toggle('md-pdp__thumb--aktiv', x === t);
      });
    });
  });

  /* Kaufen — Blatt und, wenn gewaehlt, der passende Kern in einem Aufruf. */
  /* Der Knopf der Kaufleiste fuehrt auf Zakeke-Produkten zum Konfigurator.
     Er klickt Zakekes eigenen Knopf an, statt dessen Adresse nachzubauen —
     was immer Zakeke daran haengt, gilt damit auch hier. */
  var weiter = pdp.querySelector('[data-md-zakeke-weiter]');
  if (weiter) {
    weiter.addEventListener('click', function () {
      var zk = document.getElementById('zakeke-product-button')
            || document.querySelector('#zakeke-product-button-cont button, #zakeke-product-button-cont a');
      if (zk) zk.click();
    });
  }

  function kaufen(knopf) {
    /* Zweite Sicherung. Solange Zakekes Knopf auf der Seite steht, ist das
       Produkt personalisierungspflichtig — dann darf nichts ueber diesen
       Weg in den Korb. Faenge ich es nur im Markup ab, genuegt ein
       uebersehener Aufrufer, und der Fehler ist zurueck. */
    if (document.getElementById('zakeke-product-tag')) return;

    var v = aktuelle();
    if (!v || !v.verfuegbar) return;

    var menge = mengenfeld ? Math.max(1, parseInt(mengenfeld.value, 10) || 1) : 1;
    var artikel = [{ id: v.id, quantity: menge }];
    if (bundle && bundle.checked && M.kernFuer) {
      var kern = M.kernFuer(v.titel);
      /* Gleiche Menge wie das Blatt — zwei Polster brauchen zwei Kerne. */
      if (kern) artikel.push({ id: kern.id, quantity: menge });
    }
    if (M.lege) M.lege(artikel, knopf);
  }

  var form = pdp.querySelector('[data-md-form]');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      kaufen(atc);
    });
  }

  var leisteKnopf = pdp.querySelector('[data-md-leiste-knopf]');
  if (leisteKnopf) leisteKnopf.addEventListener('click', function () { kaufen(leisteKnopf); });

  /* Die feste Leiste erscheint erst, wenn der Kaufknopf oben aus dem Bild
     gescrollt ist. */
  if (leiste && atc && 'IntersectionObserver' in window) {
    var wache = new IntersectionObserver(function (eintraege) {
      leiste.hidden = eintraege[0].isIntersecting;
    }, { rootMargin: '0px 0px -40px 0px' });
    wache.observe(atc);
  }

  auffrischen();
})();
